var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      staticClass: "containerImageCropper",
      on: {
        click: function ($event) {
          if ($event.target !== $event.currentTarget) return null
          return _vm.$emit("clickOutside")
        },
      },
    },
    [
      _c("div", { staticClass: "imageCropper" }, [
        _c(
          "div",
          { staticClass: "containerMenuRatio hide-scrollbar" },
          [
            _c("div", { staticClass: "currentSize" }, [
              _c("div", { staticClass: "title" }, [_vm._v("Résolution")]),
              _c("div", { staticClass: "inputs" }, [
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.models.resolution.width,
                      expression: "models.resolution.width",
                    },
                  ],
                  attrs: {
                    type: "number",
                    id: "width",
                    placeholder: this.models.resolutionMax.width,
                    min: 0,
                    max: this.models.resolutionMax.width,
                  },
                  domProps: { value: _vm.models.resolution.width },
                  on: {
                    keydown: _vm.onlyNumbers,
                    input: [
                      function ($event) {
                        if ($event.target.composing) return
                        _vm.$set(
                          _vm.models.resolution,
                          "width",
                          $event.target.value
                        )
                      },
                      _vm.changeNumbers,
                    ],
                  },
                }),
                _c("span", [_vm._v("x")]),
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.models.resolution.height,
                      expression: "models.resolution.height",
                    },
                  ],
                  attrs: {
                    type: "number",
                    id: "height",
                    placeholder: this.models.resolutionMax.height,
                    min: 0,
                    max: this.models.resolutionMax.height,
                  },
                  domProps: { value: _vm.models.resolution.height },
                  on: {
                    keydown: _vm.onlyNumbers,
                    input: [
                      function ($event) {
                        if ($event.target.composing) return
                        _vm.$set(
                          _vm.models.resolution,
                          "height",
                          $event.target.value
                        )
                      },
                      _vm.changeNumbers,
                    ],
                  },
                }),
              ]),
            ]),
            _vm._l(_vm.menuRatiosConfig, function (section) {
              return _c("div", { staticClass: "sectionNetwork" }, [
                _c("div", { staticClass: "title" }, [
                  _vm._v(_vm._s(section.title)),
                ]),
                _c(
                  "div",
                  { staticClass: "items" },
                  _vm._l(section.ratios, function (ratio) {
                    return _c(
                      "div",
                      {
                        staticClass: "item",
                        class: {
                          "item--active":
                            _vm.ratioSelected.network === section.title &&
                            _vm.ratioSelected.ratio === ratio.value &&
                            _vm.stencilProps.aspectRatio === ratio.value,
                        },
                        on: {
                          click: function ($event) {
                            return _vm.toggleRatio(ratio.value, section.title)
                          },
                        },
                      },
                      [
                        _c("div", { staticClass: "containerRatio" }, [
                          _c(
                            "div",
                            {
                              staticClass: "ratio",
                              style: { "aspect-ratio": ratio.value },
                            },
                            [_c("p", [_vm._v(_vm._s(ratio.label))])]
                          ),
                        ]),
                        _c("h5", [_vm._v(_vm._s(ratio.title))]),
                      ]
                    )
                  }),
                  0
                ),
              ])
            }),
          ],
          2
        ),
        _c("div", { staticClass: "editor" }, [
          _c("div", { staticClass: "header-image-cropper" }, [
            _c(
              "div",
              { staticClass: "NavSet", staticStyle: { visibility: "hidden" } },
              [
                _c(
                  "button",
                  {
                    staticClass: "Button ButtonIconOnly",
                    attrs: {
                      type: "button",
                      title: "Annuler",
                      disabled: _vm.historyIndex <= 0,
                    },
                    on: { click: _vm.undo },
                  },
                  [
                    _c(
                      "svg",
                      {
                        staticClass: "ButtonIcon",
                        attrs: {
                          width: "auto",
                          height: "auto",
                          viewBox: "0 0 24 24",
                          xmlns: "http://www.w3.org/2000/svg",
                          "aria-hidden": "true",
                          focusable: "false",
                          "stroke-linecap": "round",
                          "stroke-linejoin": "round",
                        },
                      },
                      [
                        _c("g", [
                          _c(
                            "g",
                            {
                              attrs: {
                                fill: "none",
                                "fill-rule": "evenodd",
                                "stroke-linecap": "round",
                                "stroke-linejoin": "round",
                                stroke: "currentColor",
                                "stroke-width": ".125em",
                              },
                            },
                            [
                              _c("path", {
                                attrs: {
                                  d: "M10 8h4c2.485 0 5 2 5 5s-2.515 5-5 5h-4",
                                },
                              }),
                              _c("path", {
                                attrs: {
                                  fill: "currentColor",
                                  d: "M5 8l4-3v6z",
                                },
                              }),
                            ]
                          ),
                        ]),
                      ]
                    ),
                  ]
                ),
                _c(
                  "button",
                  {
                    staticClass: "Button ButtonIconOnly",
                    attrs: {
                      type: "button",
                      title: "Refaire",
                      disabled: "",
                      disabled: _vm.historyIndex >= _vm.history.length - 1,
                    },
                    on: { click: _vm.redo },
                  },
                  [
                    _c(
                      "svg",
                      {
                        staticClass: "ButtonIcon",
                        attrs: {
                          width: "auto",
                          height: "auto",
                          viewBox: "0 0 24 24",
                          xmlns: "http://www.w3.org/2000/svg",
                          "aria-hidden": "true",
                          focusable: "false",
                          "stroke-linecap": "round",
                          "stroke-linejoin": "round",
                        },
                      },
                      [
                        _c("g", [
                          _c(
                            "g",
                            {
                              attrs: {
                                fill: "none",
                                "fill-rule": "evenodd",
                                "stroke-linecap": "round",
                                "stroke-linejoin": "round",
                                stroke: "currentColor",
                                "stroke-width": ".125em",
                              },
                            },
                            [
                              _c("path", {
                                attrs: {
                                  d: "M14 8h-4c-2.485 0-5 2-5 5s2.515 5 5 5h4",
                                },
                              }),
                              _c("path", {
                                attrs: {
                                  fill: "currentColor",
                                  d: "M19 8l-4-3v6z",
                                },
                              }),
                            ]
                          ),
                        ]),
                      ]
                    ),
                  ]
                ),
              ]
            ),
            _c("div", { staticClass: "options" }, [
              _c(
                "div",
                {
                  staticClass: "option",
                  on: {
                    click: function ($event) {
                      return _vm.$refs.cropper.rotate(-90)
                    },
                  },
                },
                [
                  _c(
                    "svg",
                    {
                      staticClass: "PinturaButtonIcon",
                      attrs: {
                        width: "auto",
                        height: "auto",
                        viewBox: "0 0 24 24",
                        xmlns: "http://www.w3.org/2000/svg",
                        "aria-hidden": "true",
                        focusable: "false",
                        "stroke-linecap": "round",
                        "stroke-linejoin": "round",
                      },
                    },
                    [
                      _c("g", [
                        _c(
                          "g",
                          { attrs: { stroke: "none", fill: "currentColor" } },
                          [
                            _c("path", {
                              attrs: { fill: "none", d: "M-1-1h582v402H-1z" },
                            }),
                            _c("rect", {
                              attrs: {
                                x: "3",
                                rx: "1",
                                height: "12",
                                width: "12",
                                y: "9",
                              },
                            }),
                            _c("path", {
                              attrs: {
                                d: "M15 5h-1a5 5 0 015 5 1 1 0 002 0 7 7 0 00-7-7h-1.374l.747-.747A1 1 0 0011.958.84L9.603 3.194a1 1 0 000 1.415l2.355 2.355a1 1 0 001.415-1.414l-.55-.55H15z",
                              },
                            }),
                          ]
                        ),
                      ]),
                    ]
                  ),
                  _vm._v(
                    "\n                        Pivoter a chauche\n                    "
                  ),
                ]
              ),
              _c(
                "div",
                {
                  staticClass: "option",
                  on: {
                    click: function ($event) {
                      return _vm.$refs.cropper.flip(true, false)
                    },
                  },
                },
                [
                  _c(
                    "svg",
                    {
                      staticClass: "PinturaButtonIcon",
                      attrs: {
                        width: "auto",
                        height: "auto",
                        viewBox: "0 0 24 24",
                        xmlns: "http://www.w3.org/2000/svg",
                        "aria-hidden": "true",
                        focusable: "false",
                        "stroke-linecap": "round",
                        "stroke-linejoin": "round",
                      },
                    },
                    [
                      _c("g", [
                        _c(
                          "g",
                          { attrs: { stroke: "none", fill: "currentColor" } },
                          [
                            _c("path", {
                              attrs: {
                                d: "M11.93 7.007V20a1 1 0 0 1-1 1H5.78a1 1 0 0 1-.93-1.368l5.15-12.993a1 1 0 0 1 1.929.368z",
                              },
                            }),
                            _c("path", {
                              attrs: {
                                d: "M14 7.007V20a1 1 0 0 0 1 1h5.149a1 1 0 0 0 .93-1.368l-5.15-12.993A1 1 0 0 0 14 7.007z",
                                opacity: ".6",
                              },
                            }),
                          ]
                        ),
                      ]),
                    ]
                  ),
                  _vm._v(
                    "\n                        Retournement horizontal\n                    "
                  ),
                ]
              ),
            ]),
            _c(
              "div",
              { staticClass: "btn-finish", on: { click: _vm.finish } },
              [_vm._v("\n                    Terminer\n                ")]
            ),
          ]),
          _c("div", { staticClass: "containerVueCropper" }, [
            _c(
              "div",
              { staticClass: "vueCropper" },
              [
                _c("Cropper", {
                  ref: "cropper",
                  attrs: {
                    src: _vm.img,
                    "background-class": "custom-background",
                    "image-restriction": "fit-area",
                    "stencil-props": _vm.stencilProps,
                    "default-size": _vm.defaultSize,
                  },
                  on: { ready: _vm.handleReady, change: _vm.change },
                }),
              ],
              1
            ),
          ]),
          _c("div", { staticClass: "footer-image-cropper" }),
        ]),
        _c(
          "div",
          {
            staticClass: "btn-reset",
            class: { disabled: !_vm.isEdit },
            on: { click: _vm.reset },
          },
          [
            _c(
              "svg",
              {
                staticClass: "ButtonIcon",
                attrs: {
                  width: "auto",
                  height: "auto",
                  viewBox: "0 0 24 24",
                  xmlns: "http://www.w3.org/2000/svg",
                  "aria-hidden": "true",
                  focusable: "false",
                  "stroke-linecap": "round",
                  "stroke-linejoin": "round",
                },
              },
              [
                _c("g", [
                  _c(
                    "g",
                    {
                      attrs: {
                        fill: "none",
                        "fill-rule": "evenodd",
                        "stroke-linecap": "round",
                        "stroke-linejoin": "round",
                        stroke: "currentColor",
                        "stroke-width": ".125em",
                      },
                    },
                    [
                      _c("path", {
                        attrs: { d: "M7.388 18.538a8 8 0 10-2.992-9.03" },
                      }),
                      _c("path", {
                        attrs: {
                          fill: "currentColor",
                          d: "M2.794 11.696L2.37 6.714l5.088 3.18z",
                        },
                      }),
                      _c("path", { attrs: { d: "M12 8v4M12 12l4 2" } }),
                    ]
                  ),
                ]),
              ]
            ),
          ]
        ),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }